/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */

/**
 * @example schema of incoming data
    [{
      "provider": "hbl",
      "responses": {
        "RESPONSE_1": {
          "status": "pending"
        },
        "RESPONSE_2": {
          "status": "error"
        }
      }
    }]
 */
/**
 * @typedef {PlagiarismReportProps}
 * @property {String} provider
 * @property {String} status
 * @property {String} href
 */
/**
 * Transform plagiarism data from incoming format to component props format
 * @param {String} responseIdentifier
 * @param {Object[]} plagiarismReports
 * @returns {PlagiarismReportProps[]}
 */
/* eslint-disable no-unused-vars */
export function normalizeReports(responseIdentifier, plagiarismReports = []) {
    if (!Array.isArray(plagiarismReports)) {
        return [];
    }
    return plagiarismReports.map(({ provider, responses }) => {
        if (!responses) {
            return;
        }
        const response = responses[responseIdentifier];
        if (response) {
            return {
                provider,
                ...response
            };
        }
    });
}
